export default "__VITE_ASSET__BuAPXvK8__"